export class UserParticipationFilter {
  page = 1;
  numberPage = 0;
  drawPage = 1;
  drawNumberPage = 0;
  purchasesPage = 1;
  purchasesNumberPage = 0;
  viewCol = 25;
  viewType = 'grid';
  mode = 'purchases';
  drawStateFilter = '';
  purchasesReceiptStateFilter = '';
  purchasesRaffleStateFilter = '';
}
